import {lighten} from 'polished';

export default {
    straight: `box-shadow: 0 0 10px ${lighten(0.75, '#000000')};`,
    side: `box-shadow: 5px 5px 10px ${lighten(0.85, '#000000')};`,
    maps: `box-shadow: 0 0 10px rgba(0,0,0,0.2);`
};
